import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=ced2b12a&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=ced2b12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced2b12a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ced2b12a')) {
      api.createRecord('ced2b12a', component.options)
    } else {
      api.reload('ced2b12a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=ced2b12a&scoped=true&", function () {
      api.rerender('ced2b12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/order/unpricedOrder/edit.vue"
export default component.exports